import { useState, useEffect } from 'react';
import { trackService, TracksListResponse } from 'data/services/trackService';
import { Track } from 'domain/track/trackContainer';

export const useAvailableTracksList = (page: number = 1, limit: number = 10, sort: string = 'title asc') => {
  const [data, setData] = useState<TracksListResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAvailableTracks = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await trackService.getAvailableTracks({ page, limit, sort });
      setData(response);
    } catch (err: any) {
      console.error('Erro ao buscar trilhas disponíveis:', err);
      setError(err?.response?.data?.message || 'Erro ao carregar trilhas disponíveis');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableTracks();
  }, [page, limit, sort]);

  const refetch = () => {
    fetchAvailableTracks();
  };

  const transformedTracks: Track[] = data?.rows?.map(track => {
    return {
      id: track.id,
      title: track.title,
      lessons: track.numberOfLessons,
      numberOfLessons: track.numberOfLessons,
      status: track.status === 'Draft' ? 'rascunho' : 'publicado',
      imageUrl: track.imageUrl,
      length: track.totalOfMinutes,
      totalOfMinutes: track.totalOfMinutes,
      description: track.description,
      createdAt: track.createdAt,
    };
  }) || [];

  return {
    data: {
      rows: transformedTracks,
      totalPages: data?.totalPages || 0,
      totalRows: data?.totalRows || 0,
      page: data?.page || 0,
      limit: data?.limit || 0,
    },
    isLoading,
    error,
    refetch,
  };
};

